import type { InferOutput } from 'valibot'
import { array, check, integer, maxLength, minLength, minValue, number, object, pipe, safeParse, string } from 'valibot'

export const PAGINATION_SOLR_FIELD = 'pagination'

const printPage = pipe(number(), integer(), minValue(1))

export const paginationSchema = pipe(
  object({
    startPage: printPage,
    breaks: array(object({ page: printPage, text: pipe(string(), minLength(1), maxLength(200)) })),
  }),
  check(
    ({ startPage, breaks }) => breaks.every((item, index) => item.page > (index === 0 ? startPage : breaks[index - 1]!.page)),
    'Break pages must increase strictly above startPage',
  ),
)

export type SectionPagination = InferOutput<typeof paginationSchema>

export function parsePagination(raw: unknown): SectionPagination | undefined {
  // A multi-valued Solr string field delivers its single value wrapped in an array.
  let value = Array.isArray(raw) && raw.length === 1 ? raw[0] : raw
  if (typeof value === 'string') {
    try {
      value = JSON.parse(value)
    }
    catch {
      return undefined
    }
  }
  const result = safeParse(paginationSchema, value)
  return result.success ? result.output : undefined
}
